import ApplicationAdapter from 'eflex/adapters/application';

export default class TurckIoAdapter extends ApplicationAdapter {
  pathForType() {
    return 'hardwares';
  }
}
